import React, { useState, useEffect } from 'react';
import { Menu, MenuItem, InputGroup } from '@blueprintjs/core'

export default (props) => {

    const [filter, setFilter] = useState('');

    return (
        <>
            <InputGroup
                large
                placeholder={'Filter'}
                leftIcon={'search'}
                onChange={(e) => {
                    setFilter(e.target.value)
                }}
            />
            <Menu style={{
                maxHeight: '75vh',
                overflow: 'auto'
            }}>
                {props.countries.filter((country) => (filter.length == 0 || country.name.toLowerCase().indexOf(filter.toLowerCase()) > -1)).map((country) => (
                    <MenuItem
                        text={<div dangerouslySetInnerHTML={{ __html: country.name }}></div>}
                        large
                        active={props.selected && props.selected.indexOf(country.id) > -1}
                        onClick={() => {
                            props.onClick && props.onClick(country);
                        }}
                    />
                ))}
            </Menu>
        </>
    )

}